module.exports = __webpack_public_path__ + "3a8fca6aa7dd75f15250c490b13d298f.MP3";